<template>
  <div class="d-flex flex-row nly-container">
    <div region="nly-aside" :class="nlyAsideClass">
      <!-- brand -->
      <router-link to="" class="nly-container-aside-brand text-center">
        <!-- <img
          src="../../static/images/log.gif"
          class="nly-container-aside-brand-image"
          style="opacity: .8"
        /> -->
        <span
          class="nly-container-aside-brand-text"
          style="
            font-family: 'KaiTi';
            text-shadow: 0 0 10px #fff;
            font-size: 20px;
          "
          >华源医药</span
        >
      </router-link>

      <!-- Sidebar -->
      <div class="nly-container-aside-sidebar-scrollbar">
        <div class="nly-container-aside-sidebar">
          <div
            class="mt-3 pb-3 mb-3 d-flex nly-container-aside-sidebar-user-panel"
          >
            <div class="nly-container-aside-sidebar-user-panel-image">
              <!-- <img
                src="../../static/images/logo1.jpg"
                class="nly-container-aside-sidebar-user-panel-image-img"
                alt="userimg"
              /> -->
              <img
                src="../../static/images/caidan.png"
                style="width: 20px; height: 20px"
                class="mt-1"
                alt=""
              />
            </div>
            <div class="nly-container-aside-sidebar-user-panel-info">
              <a
                href="#"
                class="nly-container-aside-sidebar-user-panel-info-block"
              >
                <span> 菜单 </span>
              </a>
            </div>
          </div>

          <!-- Sidebar Menu -->
          <b-nav vertical class="nly-container-aside-sidebar-menu">
            <b-nav
              role="tablist"
              class="nly-container-aside-sidebar-menu-nav nav-pills flex-column"
            >
              <!-- <b-nav-item
                active
                link-classes="nly-container-aside-sidebar-menu-nav-item-nav-link"
                class="nly-container-aside-sidebar-menu-nav-item"
              >
                <i
                  class="nly-container-aside-sidebar-menu-nav-item-icon fas fa-th"
                ></i>
                <p class="nly-container-aside-sidebar-menu-nav-item-nav-link-p">
                  仪表盘
                </p>
              </b-nav-item> -->
              <!-- <b-nav-item
                link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-link"
                class="nly-container-aside-sidebar-menu-nav-item-open"
                v-b-toggle.accordion-1
                active
              >
                <i
                  class="nly-container-aside-sidebar-menu-nav-item-open-icon fas fa-tachometer-alt"
                ></i>
                <p
                  class="nly-container-aside-sidebar-menu-nav-item-open-nav-link-p"
                >
                   全部功能
                  <i
                    class="when-opened nly-container-aside-sidebar-menu-nav-item-open-icon-right fas fa-angle-left"
                  ></i>
                  <i
                    class="when-closed nly-container-aside-sidebar-menu-nav-item-open-icon-right-off fas fa-angle-left"
                  ></i>
                </p>
              </b-nav-item> -->
              <b-nav-item
                link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-link"
                class="nly-container-aside-sidebar-menu-nav-item-open"
                v-b-toggle.accordion-1
                active
              >
                <!-- <i
                  class="nly-container-aside-sidebar-menu-nav-item-open-icon fas fa-tachometer-alt"
                ></i> -->
                <img
                  src="../../static/images/go.png"
                  style="width: 20px; height: 20px"
                  class="mb-1"
                  alt=""
                />
                <p
                  class="
                    nly-container-aside-sidebar-menu-nav-item-open-nav-link-p
                  "
                >
                  全部功能
                  <i
                    class="
                      when-opened
                      nly-container-aside-sidebar-menu-nav-item-open-icon-right
                      fas
                      fa-angle-left
                    "
                  ></i>
                  <i
                    class="
                      when-closed
                      nly-container-aside-sidebar-menu-nav-item-open-icon-right-off
                      fas
                      fa-angle-left
                    "
                  ></i>
                </p>
              </b-nav-item>
              <ul class="nly-container-aside-sidebar-menu-nav">
                <b-collapse
                  id="accordion-1"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                  tag="li"
                  class="nly-container-aside-sidebar-menu-nav-item-open"
                >
                  <!-- <b-nav-item
                    active
                    link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link"
                    class="nly-container-aside-sidebar-menu-nav-item-open"
                  >
                    <i
                      class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon fas fa-th"
                    ></i>
                    <p
                      class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p"
                    >
                      我是猕猴桃
                    </p>
                  </b-nav-item> -->
                  <b-nav-item
                    link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link"
                    class="nly-container-aside-sidebar-menu-nav-item-open"
                    v-for="(item, index) in list"
                    :key="index"
                    :to="item.role"
                  >
                    <div v-if="item.role != '' || item.role != null">
                      <i
                        class="
                          nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon
                          fas
                          fa-th
                        "
                      ></i>

                      <p
                        class="
                          nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p
                        "
                      >
                        {{ item.name }}
                        <span
                          v-if="
                            item.name == '调价' ||
                            item.name == '移库' ||
                            item.name == '返利' ||
                            item.name == '结款申请' ||
                            item.name == '医院汇款认领'
                          "
                          style="color: red"
                        >
                          (vip测试)
                        </span>
                      </p>
                    </div>
                  </b-nav-item>
                </b-collapse>
              </ul>

              <!-- <b-nav-item
                link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-link"
                class="nly-container-aside-sidebar-menu-nav-item-open"
                v-b-toggle.accordion-2
              >
                <i
                  class="nly-container-aside-sidebar-menu-nav-item-open-icon fas fa-tachometer-alt"
                ></i>
                 <img src="../../static/images/go.png" style="width:20px;height:20px;" class="mb-1" alt="">
                <p
                  class="nly-container-aside-sidebar-menu-nav-item-open-nav-link-p"
                >
                  全部功能
                  <i
                    class="when-opened nly-container-aside-sidebar-menu-nav-item-open-icon-right fas fa-angle-left"
                  ></i>
                  <i
                    class="when-closed nly-container-aside-sidebar-menu-nav-item-open-icon-right-off fas fa-angle-left"
                  ></i>
                </p>
              </b-nav-item> -->
              <!-- <ul class="nly-container-aside-sidebar-menu-nav">
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                  tag="li"
                  class="nly-container-aside-sidebar-menu-nav-item-open"
                >
                  <b-nav-item
                    link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link"
                    class="nly-container-aside-sidebar-menu-nav-item-open"
                    v-for="(item,index) in list" :key="index"
                    :to="item.role"
                   >
                            <i
                              class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon fas fa-th"
                            ></i>
                            <p
                              class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p hover_p"
                            >
                             {{item.name}}
                            </p>
                  </b-nav-item>
                  <b-nav-item
                    link-classes="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link"
                    class="nly-container-aside-sidebar-menu-nav-item-open"
                  >
                    <i
                      class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon fas fa-th"
                    ></i>
                    <p
                      class="nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p"
                    >
                      我是绿色
                    </p>
                  </b-nav-item>
                </b-collapse>
              </ul> -->
            </b-nav>
          </b-nav>

          <!-- /.sidebar-menu -->
        </div>
      </div>
    </div>
    <div class="center flex-fill nly-container-center-scrollbar">
      <div region="nly-container-center" class="nly-container-center">
        <div class="nly-container-center-content">
          <div
            region="nly-container-center-content-header"
            class="nly-container-center-content-header"
          >
            <div>
              <b-navbar toggleable="lg" type="dark">
                <button
                  type="button"
                  aria-label="Toggle navigation"
                  aria-controls="self"
                  aria-expanded="false"
                  class="
                    navbar-toggler
                    nly-container-center-content-main-aside-toggle
                  "
                  @click="changeaside"
                >
                  <span>
                    <b-icon icon="bar-chart" />
                  </span>
                </button>

                <button
                  type="button"
                  aria-label="Toggle navigation"
                  aria-controls="self"
                  aria-expanded="false"
                  class="
                    navbar-toggler
                    nly-container-center-content-main-aside-open-toggle
                  "
                  @click="changeopen"
                >
                  <span>
                    <b-icon icon="bar-chart" />
                  </span>
                </button>

                <b-navbar-brand
                  href="#"
                  class="nly-container-center-content-header-brand m-auto"
                >
                  <img
                    :src="logo"
                    alt="nejinn lerity admin"
                    class="nly-container-center-content-header-brand-img"
                  />
                  <span class="nly-container-center-content-header-brand-text">
                    HY
                  </span>
                </b-navbar-brand>

                <b-navbar-toggle
                  target="nav-collapse"
                  class="nly-container-center-content-main-aside-open-toggle"
                ></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                  <!-- <b-navbar-nav>
                    <b-nav-item href="#">展开</b-nav-item>
                    <b-nav-form>
                      <b-form-input
                        size="sm"
                        class="ml-sm-3"
                        placeholder="搜索"
                      ></b-form-input>
                       <b-button
                        size="sm"
                        class="my-2 my-sm-0 ml-sm-1"
                        type="submit"
                        >搜索</b-button
                      >
                    </b-nav-form>
                  </b-navbar-nav> -->
                  <!-- Right aligned nav items -->
                  <b-navbar-nav class="ml-auto">
                    <!-- <b-nav-item-dropdown text="Lang" right>
                      <b-dropdown-item href="#">EN</b-dropdown-item>
                      <b-dropdown-item href="#">ES</b-dropdown-item>
                      <b-dropdown-item href="#">RU</b-dropdown-item>
                      <b-dropdown-item href="#">FA</b-dropdown-item>
                    </b-nav-item-dropdown> -->
                    <img
                      src="../../static/images/yu.gif"
                      class="mt-1"
                      style="width: 30px; height: 30px; border-radius: 5px"
                      alt=""
                    />
                    <b-nav-item-dropdown
                      right
                      no-caret
                      toggle-class="nly-container-center-content-header-navbar-nav-dropdown-navlink"
                    >
                      <template v-slot:button-content>
                        <span v-if="groupid == 5">代理商</span>
                        <span v-if="groupid == 51">代理商</span>
                        <span v-if="groupid == 7">厂商</span>
                        <span v-if="groupid == 26">外销业务员</span>
                        <span v-if="groupid == 66">总经理</span>
                        <b-icon class="mb-1" icon="person" />
                      </template>
                      <b-dropdown-item>
                        <img
                          src="../../static/images/header.gif"
                          class="mb-1"
                          style="width: 20px; height: 20px; border-radius: 5px"
                          alt=""
                        />
                        用户:
                        <span style="color: green">{{ username }}</span>
                      </b-dropdown-item>
                      <!-- <b-dropdown-item to="/unbind">
                         <img src="../../static/images/shouji.png" class="mb-1" style="width:20px;height:20px;border-radius:5px;" alt="">
                            解绑手机
                      </b-dropdown-item> -->
                      <b-dropdown-item
                        class="text-center"
                        @click="clearLogin()"
                        to="/"
                      >
                        退出登录
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>
                </b-collapse>
              </b-navbar>
            </div>
          </div>
          <div
            region="nly-container-center-content-main"
            class="
              center
              flex-fill flex-column
              nly-container-center-content-main
            "
          >
            <b-breadcrumb>
              <div
                class="
                  nly-container-center-content-main-breadcrumb-left
                  mr-auto
                  col-sm-5
                "
              >
                <router-link
                  to="/index"
                  v-if="
                    groupid == 5 ||
                    groupid == 7 ||
                    groupid == 26 ||
                    groupid == 51
                  "
                >
                  <b-icon
                    icon="house-fill"
                    scale="1.25"
                    shift-v="1.25"
                    aria-hidden="true"
                  ></b-icon>
                  <span
                    style="
                      font-family: 'KaiTi';
                      text-shadow: 0 0 10px #fff;
                      font-size: 20px;
                    "
                    >首页</span
                  >
                </router-link>
                <router-link to="/salesGournal" v-if="groupid == 66">
                  <b-icon
                    icon="house-fill"
                    scale="1.25"
                    shift-v="1.25"
                    aria-hidden="true"
                  ></b-icon>
                  <span
                    style="
                      font-family: 'KaiTi';
                      text-shadow: 0 0 10px #fff;
                      font-size: 20px;
                    "
                    >销售日报</span
                  >
                </router-link>
                <router-link to="/favorite" v-if="groupid == 66">
                  <span
                    class="ml-3"
                    style="
                      font-family: 'KaiTi';
                      text-shadow: 0 0 10px #fff;
                      font-size: 20px;
                    "
                    >收藏的日志</span
                  >
                </router-link>
              </div>

              <div class="col-sm-2">
                <router-link
                  to="/downLoadApp"
                  style="
                    font-family: 'KaiTi';
                    text-shadow: 0 0 10px #fff;
                    font-size: 20px;
                  "
                  class="xia_zai"
                >
                  <span>掌上华源下载</span>
                </router-link>
              </div>

              <div
                class="
                  nly-container-center-content-main-breadcrumb-right
                  col-sm-5
                  justify-content-sm-end
                  align-self-center
                "
                style="font-size: 15px"
              >
                <b-breadcrumb-item
                  to="/index"
                  v-if="
                    groupid == 5 ||
                    groupid == 7 ||
                    groupid == 26 ||
                    groupid == 51
                  "
                >
                  <b-icon
                    icon="house-fill"
                    scale="1.25"
                    shift-v="1.25"
                    aria-hidden="true"
                  ></b-icon>
                  首页
                </b-breadcrumb-item>
                <b-breadcrumb-item to="/salesGournal" v-if="groupid == 66">
                  <b-icon
                    icon="house-fill"
                    scale="1.25"
                    shift-v="1.25"
                    aria-hidden="true"
                  ></b-icon>
                  销售日报
                </b-breadcrumb-item>

                <b-breadcrumb-item to="/password"> 修改密码 </b-breadcrumb-item>
                <!-- <b-breadcrumb-item to="/password">
                            实名认证
                </b-breadcrumb-item> -->
              </div>
            </b-breadcrumb>
            <!-- 这里是页面主内容 -->
            <div>
              <!-- 这里添加页面切入效果 -->
              <!-- <div class="row scroll_content" v-if="groupid==66||groupid==77">
                   <div>
                      <img class="scrollBox" src="../../static/images/laba.png" alt="">
                   </div>
                  <div>
                      <Scroller :lists="lists" class="scrollContainer left" />
                  </div>
              </div> -->
              <!-- <div>
                            <b-button v-b-toggle.sidebar-right>Toggle Sidebar</b-button>
                            <b-sidebar id="sidebar-right" title="Sidebar" right shadow>
                            <div class="px-3 py-2">
                                <p>
                                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis
                                in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                                </p>
                                <b-img src="https://picsum.photos/500/500/?image=54" fluid thumbnail></b-img>
                            </div>
                            </b-sidebar>
                          </div> -->
              <transition name="fade" mode="out-in">
                <router-view></router-view>
              </transition>
            </div>
          </div>
          <!-- <div
            region="nly-container-center-content-foot"
            class="nly-container-center-content-foot"
          >
            华源医药
          </div>
          <div
            class="nly-container-aside-max-open-overlay"
            v-show="overlay"
            @click="changeoverlay"
          ></div> -->
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close m-0 p-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin: 0 auto">
            <table style="width: 750px">
              <tr class="text-center" style="font-size: 20px">
                <th>部门</th>
                <th>评分</th>
                <th>说明</th>
              </tr>
              <tr
                v-for="(item, index) in bmList"
                :key="index"
                class="text-center"
              >
                <td style="font-size: 15px">{{ item.departmentname }}</td>
                <td style="width: 400px">
                  <rater
                    class="diy-box"
                    :score="curScore"
                    @change="changeHandler($event, index)"
                  ></rater>
                  <!-- <my-rate :score.sync="curScore" showText/> -->
                </td>
                <td>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    style="width: 100%; height: 80px"
                    v-model="item.value"
                  ></textarea>
                </td>
              </tr>
            </table>
            <p class="text-center mt-3 mb-3">
              <button class="btn btn-primary" @click="UpDatebumen()">
                提交
              </button>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <span aria-hidden="true"></span>关闭
            </button>
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal"><span aria-hidden="true"></span>确定</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from "../assets/logo.png";
import Scroller from "../pages/manager/Scroller.vue";
// import MyRate from "./common/MyRate.vue";
import rater from "w-rater";
import { async } from "q";
export default {
  data() {
    return {
      nlyAsideClass: "nly-container-aside-max",
      logo,
      overlay: false,
      openMenu: true,
      boss: "",
      username: "",
      groupid: "",
      list2state: false,
      list2: [],
      list: [],
      lists: [" "],
      bmList: [],
      curScore: 0,
      raterList: [],
      pjList: [],
      flag: true,
      groupid1: "",
      list3: [],
    };
  },

  components: {
    Scroller,
    rater,
  },
  methods: {
    //提交评价
    UpDatebumen: async function () {
      const that = this;
      that.flag = true;
      //
      that.bmList.forEach((item, index) => {
        that.pjList[index] = {
          bumenid: item.id,
          bumenname: item.departmentname,
          pf: that.raterList[index],
          context: item.value,
        };
      });
      //
      that.pjList.forEach((item) => {
        if (item.pf < 3 && item.context == "") {
          that.flag = false;
        }
      });
      if (that.flag) {
        const { data: res } = await that.$http.post("Dls/UpDatebumen", {
          list: that.pjList,
        });
        //
        if (res.isok) {
          alert(res.message);
        }
      } else {
        alert("检测到评分有一般以下的评论没有添加说明，请添加后再进行操作！");
      }
    },

    //获取星星数量
    changeHandler(score, index) {
      this.raterList[index] = score;
      //
    },
    //获取部门评价
    GetbmState: async function () {
      const that = this;
      await that.$http.post("Dls/GetbmState", {}).then((res) => {
        //
        if (res.data.isok) {
          if (that.groupid == 5) {
            that.bmList = res.data.data;
            that.bmList.forEach((item, index) => {
              item.value = "";
              that.raterList[index] = 0;
            });

            $("#myModal").modal();
          }
        }
      });
    },

    changeopen() {
      if (this.nlyAsideClass == "nly-container-aside-max") {
        this.nlyAsideClass = "nly-container-aside-max-open";
        this.overlay = true;
      } else if (this.nlyAsideClass == "nly-container-aside-mini") {
        this.nlyAsideClass = "nly-container-aside-max-open";
        this.overlay = true;
      } else {
        this.nlyAsideClass = "nly-container-aside-max";
        this.overlay = false;
      }
    },
    changeaside() {
      this.nlyAsideClass =
        this.nlyAsideClass == "nly-container-aside-mini"
          ? "nly-container-aside-max"
          : "nly-container-aside-mini";
    },
    changeoverlay() {
      if (this.overlay == true) {
        this.nlyAsideClass = "nly-container-aside-max";
        this.overlay = false;
      }
    },
    changeMenuStatus() {
      this.openMenu = this.openMenu == true ? false : true;
    },
    getBoss() {
      this.boss = window.sessionStorage.getItem("boss");
      this.username = window.sessionStorage.getItem("username");
      this.groupid = window.sessionStorage.getItem("groupid");
    },
    clearLogin() {
      window.sessionStorage.clear();
    },
    geList: async function () {
      const that = this;
      const { data: res } = await that.$http.post("Dls/getQxListnew", {});
      //
      that.list = res.data;
      //this.getuser();
      if (that.list.length > 0) {
        that.list.forEach((item, index) => {
          if (
            item.name == "医院汇款认领" &&
            window.sessionStorage.getItem("username").slice(0, 2) != "a6"
          ) {
            that.list.splice(index, 1);
          }
        });
      }
      //
    },
    // geList1: async function(){
    //        const that=this
    //        const { data: res } = await that.$http.post('Dls/getQxList',{
    //          groupid:this.groupid1
    //        })
    //
    //        that.list3=[];
    //        that.list3=res.data
    //        that.list.concat(that.list3)

    //
    // },

    getuser: async function () {
      const that = this;
      const { data: res } = await that.$http.post("Dls/getuserstate2", {});
      //
      if (res.isOk) {
        that.list3 = [];
        that.list3 = res.data;
        //
        that.list = that.list.concat(that.list3);
        //
      }
      // if(res.data.length==0){

      // }else{
      //   let data=res.data[0];
      //   for(let i=0;i<res.data.length;i++){
      //     that.groupid1= res.data[i].groupid;
      //     //用groupid 重新请求getqxlist  -----如果不是空----- 新返回的列表往list添加
      //     //可以定义一个新的list2   每次请求，都把list2先置 2.3 4现在返回的都是空---包括部门评价
      //   }
      //   if(data.groupid==3){
      //     that.list2state=true;

      //     that.list2[0]={
      //           "name": "会议纪要",
      //           "role": "/summaryMeeting",
      //           "mobileRole": "pages/general/meetingSummary",
      //           "fid": "-1"

      //       }
      //       that.list.push(that.list2[0])
      //   }
      //   if(data.groupid==2){
      //     that.list2state=true;

      //     that.list2[0]={
      //     "name": "会议审核",
      //     "role": "/checkMeeting",
      //     "mobileRole": "pages/meeting/meetingReview",
      //     "fid": "-1"
      // }
      //        that.list.push(that.list2[0])
      //   }
      //   if(data.groupid==4){
      //     that.list2state=true;

      //     that.list2[0]={
      //       "name": "会议督办",
      //       "role": "/superviseMeeting",
      //       "mobileRole": "pages/meeting/supervise",
      //       "fid": "-1"
      //   }
      //    that.list2[1]={
      //       "name": "部门评价",
      //       "role": "/evaluate",
      //       "mobileRole": "pages/Pj/Evaluate",
      //       "fid": "-1"
      //   }
      //        that.list.push(that.list2[0])
      //        that.list.push(that.list2[1])
      //   }
      // }

      //
    },
  },
  // beforeRouteLeave(to,from,next){
  //
  //      if(to.name=="myLog"){
  //        to.meta.keepAlive=false;
  //      }
  //      next();
  // },
  created() {
    this.getBoss();
    this.geList();

    this.GetbmState();
  },
  watch: {
    // 检测罩层变化
    nlyAsideClass(newvar) {
      if (newvar != "nly-container-aside-max-open") {
        this.overlay = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@basezindex: 10;

// 边侧容器
.nly-container {
  height: 100%;
  width: 100%;
  background-color: #343a40;
}

// 默认大屏边侧栏
.nly-container-aside-max {
  height: 100%;
  width: 16rem;
  background-color: #343a40;
  transition: 0.5s;

  .nly-container-aside-brand:hover {
    color: #ffffff;
    text-decoration: none;
  }
  .nly-container-aside-brand {
    display: block;
    font-size: 1.25rem;
    line-height: 1.5;
    padding: 0.8125rem 0.5rem;
    transition: width 0.3s ease-in-out;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.8);
    border-bottom: 1px solid #4e5257;
    position: static;

    .nly-container-aside-brand-image {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23) !important;
    }

    .nly-container-aside-brand-text {
      font-weight: 300;
      display: inline-block;
      margin-left: 0;
      opacity: 1;
      visibility: visible;
      transition: margin-left 0.3s linear, opacity 0.3s ease,
        visibility 0.3s ease;
    }
  }

  .nly-container-aside-sidebar-scrollbar {
    overflow: auto;
    height: calc(~"100vh - 58px");
  }

  .nly-container-aside-sidebar:hover {
    overflow: auto;
    // margin-right: 0rem;
    // padding-right: 0.5rem;
  }

  .nly-container-aside-sidebar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.5rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.5rem;
  }
  .nly-container-aside-sidebar::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #4374b1;
  }

  .nly-container-aside-sidebar::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #4e525741;
  }

  .nly-container-aside-sidebar {
    height: calc(100% - 0.7rem);
    overflow: hidden;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    // margin-right: 0.5rem;
    padding-top: 0;

    .nly-container-aside-sidebar-user-panel {
      position: relative;
      border-bottom: 1px solid #4e5257;
      .nly-container-aside-sidebar-user-panel-image {
        display: inline-block;
        padding-left: 0.8rem;
        .nly-container-aside-sidebar-user-panel-image-img {
          max-height: 2.1rem;
          border-radius: 50%;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23) !important;
        }
      }
      .nly-container-aside-sidebar-user-panel-info {
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        padding: 5px 5px 5px 10px;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
        .nly-container-aside-sidebar-user-panel-info-block {
          display: block !important;
          color: rgba(255, 255, 255, 0.8);
        }
        .nly-container-aside-sidebar-user-panel-info-block:hover {
          display: block !important;
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
    .nly-container-aside-sidebar-menu {
      margin-top: 0.5rem !important;
      .nly-container-aside-sidebar-menu-nav {
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        margin-top: 0;
      }

      .nly-container-aside-sidebar-menu-nav-item {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
          .nly-container-aside-sidebar-menu-nav-item-nav-link-p {
            transition: margin-left 0.3s linear, opacity 0.3s ease,
              visibility 0.3s ease;
            display: inline-block;
            margin: 0;
            display: inline-block;
            opacity: 1;
            visibility: visible;
          }
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open.collapsed {
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          .when-opened {
            display: none;
          }
          .when-closed {
            display: block;
          }
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
          .when-closed {
            display: none;
          }
          .when-opened {
            display: block;
          }
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
        .nly-container-aside-sidebar-menu-nav-item-open-icon-right-off {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link.active {
          background-color: rgba(255, 255, 255, 0.9);
          color: #343a40;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon.fas {
          font-size: 1.1rem;
        }
      }
    }
  }
}

// 收起边侧栏
.nly-container-aside-mini {
  height: 100%;
  width: 4.5rem;
  background-color: #343a40;
  transition: 0.5s;

  .nly-container-aside-brand:hover {
    color: #ffffff;
    text-decoration: none;
  }
  .nly-container-aside-brand {
    display: block;
    font-size: 1.25rem;
    line-height: 1.5;
    padding: 0.8125rem 0.5rem;
    transition: width 0.3s ease-in-out;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.8);
    border-bottom: 1px solid #4e5257;
    position: static;

    .nly-container-aside-brand-image {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23) !important;
    }

    .nly-container-aside-brand-text {
      margin-left: -10px;
      opacity: 0;
      visibility: hidden;
      font-weight: 300;
      transition: margin-left 0.3s linear, opacity 0.3s ease,
        visibility 0.3s ease;
    }
  }

  .nly-container-aside-sidebar-scrollbar {
    overflow: auto;
    height: calc(~"100vh - 58px");
  }

  .nly-container-aside-sidebar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.5rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.5rem;
  }
  .nly-container-aside-sidebar::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #4374b1;
  }

  .nly-container-aside-sidebar::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #4e525741;
  }

  .nly-container-aside-sidebar:hover {
    height: calc(100% - 4rem);
    overflow: auto;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;
  }
  .nly-container-aside-sidebar {
    height: calc(100% - 0.7rem);
    overflow: hidden;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;
    .nly-container-aside-sidebar-user-panel {
      position: relative;
      border-bottom: 1px solid #4e5257;
      .nly-container-aside-sidebar-user-panel-image {
        display: inline-block;
        padding-left: 0.8rem;
        .nly-container-aside-sidebar-user-panel-image-img {
          max-height: 2.1rem;
          border-radius: 50%;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23) !important;
        }
      }
      .nly-container-aside-sidebar-user-panel-info {
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        padding: 5px 5px 5px 10px;
        color: rgba(255, 255, 255, 0.8);
        margin-left: -10px;
        opacity: 0;
        visibility: hidden;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
        .nly-container-aside-sidebar-user-panel-info-block {
          display: block !important;
          color: rgba(255, 255, 255, 0.8);
        }
        .nly-container-aside-sidebar-user-panel-info-block:hover {
          display: block !important;
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
    .nly-container-aside-sidebar-menu {
      margin-top: 0.5rem !important;
      .nly-container-aside-sidebar-menu-nav {
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        margin-top: 0;
      }

      .nly-container-aside-sidebar-menu-nav-item {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0 0 0 -10px;
          opacity: 0;
          visibility: hidden;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open.collapsed {
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          .when-opened {
            display: none;
          }
          .when-closed {
            display: block;
          }
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
          .when-closed {
            display: none;
          }
          .when-opened {
            display: block;
          }
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0 0 0 -10px;
          opacity: 0;
          visibility: hidden;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
        .nly-container-aside-sidebar-menu-nav-item-open-icon-right-off {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0 0 0 -10px;
          opacity: 0;
          visibility: hidden;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link.active {
          background-color: rgba(255, 255, 255, 0.9);
          color: #343a40;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon.fas {
          font-size: 1.1rem;
        }
      }
    }
  }
}

// 滑过收起边侧栏
.nly-container-aside-mini:hover {
  height: 100%;
  width: 16rem;
  background-color: #343a40;
  transition: 0.5s;

  .nly-container-aside-brand:hover {
    color: #ffffff;
    text-decoration: none;
  }

  .nly-container-aside-brand {
    display: block;
    font-size: 1.25rem;
    line-height: 1.5;
    padding: 0.8125rem 0.5rem;
    transition: width 0.3s ease-in-out;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.8);
    border-bottom: 1px solid #4e5257;
    position: static;

    .nly-container-aside-brand-image {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23) !important;
    }

    .nly-container-aside-brand-text {
      font-weight: 300;
      display: inline-block;
      margin-left: 0;
      opacity: 1;
      visibility: visible;
      transition: margin-left 0.3s linear, opacity 0.3s ease,
        visibility 0.3s ease;
    }
  }

  .nly-container-aside-sidebar-scrollbar {
    overflow: auto;
    height: calc(~"100vh - 58px");
  }

  .nly-container-aside-sidebar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.5rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.5rem;
  }
  .nly-container-aside-sidebar::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #4374b1;
  }

  .nly-container-aside-sidebar::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #4e525741;
  }

  .nly-container-aside-sidebar:hover {
    height: calc(100% - 4rem);
    overflow: auto;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;
  }
  .nly-container-aside-sidebar {
    height: calc(100% - 0.7rem);
    overflow: hidden;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;
    .nly-container-aside-sidebar-user-panel {
      position: relative;
      border-bottom: 1px solid #4e5257;
      .nly-container-aside-sidebar-user-panel-image {
        display: inline-block;
        padding-left: 0.8rem;
        .nly-container-aside-sidebar-user-panel-image-img {
          max-height: 2.1rem;
          border-radius: 50%;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23) !important;
        }
      }
      .nly-container-aside-sidebar-user-panel-info {
        display: inline-block;
        margin-left: 0;
        opacity: 1;
        visibility: visible;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;

        overflow: hidden;
        white-space: nowrap;
        padding: 5px 5px 5px 10px;
        .nly-container-aside-sidebar-user-panel-info-block {
          display: block !important;
          color: rgba(255, 255, 255, 0.8);
        }
        .nly-container-aside-sidebar-user-panel-info-block:hover {
          display: block !important;
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
    .nly-container-aside-sidebar-menu {
      margin-top: 0.5rem !important;
      .nly-container-aside-sidebar-menu-nav {
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        margin-top: 0;
      }

      .nly-container-aside-sidebar-menu-nav-item {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open.collapsed {
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          .when-opened {
            display: none;
          }
          .when-closed {
            display: block;
          }
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
          .when-closed {
            display: none;
          }
          .when-opened {
            display: block;
          }
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
        .nly-container-aside-sidebar-menu-nav-item-open-icon-right-off {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link.active {
          background-color: rgba(255, 255, 255, 0.9);
          color: #343a40;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon.fas {
          font-size: 1.1rem;
        }
      }
    }
  }
}

// 移动端边侧栏
.nly-container-aside-max-open {
  height: 100%;
  width: 16rem;
  background-color: #343a40;
  transition: 0.5s;

  .nly-container-aside-brand:hover {
    color: #ffffff;
    text-decoration: none;
  }
  .nly-container-aside-brand {
    display: block;
    font-size: 1.25rem;
    line-height: 1.5;
    padding: 0.8125rem 0.5rem;
    transition: width 0.3s ease-in-out;
    white-space: nowrap;
    color: rgba(255, 255, 255, 0.8);
    border-bottom: 1px solid #4e5257;
    position: static;

    .nly-container-aside-brand-image {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23) !important;
    }

    .nly-container-aside-brand-text {
      font-weight: 300;
      display: inline-block;
      margin-left: 0;
      opacity: 1;
      visibility: visible;
      transition: margin-left 0.3s linear, opacity 0.3s ease,
        visibility 0.3s ease;
    }
  }

  .nly-container-aside-sidebar-scrollbar {
    overflow: auto;
    height: calc(~"100vh - 58px");
  }

  .nly-container-aside-sidebar::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 0.5rem; /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.5rem;
  }
  .nly-container-aside-sidebar::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #4374b1;
  }

  .nly-container-aside-sidebar::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #4e525741;
  }
  .nly-container-aside-sidebar:hover {
    height: calc(100% - 4rem);
    overflow: auto;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;
  }
  .nly-container-aside-sidebar {
    height: calc(100% - 0.7rem);
    overflow: hidden;
    padding-bottom: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0;

    .nly-container-aside-sidebar-user-panel {
      position: relative;
      border-bottom: 1px solid #4e5257;
      .nly-container-aside-sidebar-user-panel-image {
        display: inline-block;
        padding-left: 0.8rem;
        .nly-container-aside-sidebar-user-panel-image-img {
          max-height: 2.1rem;
          border-radius: 50%;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23) !important;
        }
      }
      .nly-container-aside-sidebar-user-panel-info {
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
        padding: 5px 5px 5px 10px;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
        .nly-container-aside-sidebar-user-panel-info-block {
          display: block !important;
          color: rgba(255, 255, 255, 0.8);
        }
        .nly-container-aside-sidebar-user-panel-info-block:hover {
          display: block !important;
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
    .nly-container-aside-sidebar-menu {
      margin-top: 0.5rem !important;
      .nly-container-aside-sidebar-menu-nav {
        white-space: nowrap;
        overflow: hidden;
        position: relative;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        margin-top: 0;
      }

      .nly-container-aside-sidebar-menu-nav-item {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open.collapsed {
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          .when-opened {
            display: none;
          }
          .when-closed {
            display: block;
          }
        }
      }

      .nly-container-aside-sidebar-menu-nav-item-open {
        margin-bottom: 0;
        width: 100%;
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
          .when-closed {
            display: none;
          }
          .when-opened {
            display: block;
          }
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-link.active {
          background-color: #007bff;
          color: #ffffff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon.fas {
          font-size: 1.1rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-icon-right {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
        .nly-container-aside-sidebar-menu-nav-item-open-icon-right-off {
          transition: -webkit-transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s;
          transition: transform ease-in-out 0.3s,
            -webkit-transform ease-in-out 0.3s;
          position: absolute;
          right: 1rem;
          top: 0.7rem;
          font-weight: 900;
          -webkit-font-smoothing: antialiased;
          display: inline-block;
          font-style: normal;
          font-variant: normal;
          text-rendering: auto;
          line-height: 1;
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link {
          position: relative;
          display: block;
          padding: 0.5rem 1rem;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 0.2rem;
          color: #ffffff;
          border-radius: 0.25rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link-p {
          transition: margin-left 0.3s linear, opacity 0.3s ease,
            visibility 0.3s ease;
          display: inline-block;
          margin: 0;
          display: inline-block;
          opacity: 1;
          visibility: visible;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:hover,
        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link:focus {
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-link.active {
          background-color: rgba(255, 255, 255, 0.9);
          color: #343a40;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon {
          font-size: 1.2rem;
          margin-right: 0.2rem;
          text-align: center;
          width: 1.6rem;
        }

        .nly-container-aside-sidebar-menu-nav-item-open-nav-item-icon.fas {
          font-size: 1.1rem;
        }
      }
    }
  }
}

// 边侧栏头片

.nly-container-center-scrollbar {
  overflow: auto;
  height: calc(~"100vh - 1px");
}

.nly-container-center::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0.5rem; /*高宽分别对应横竖滚动条的尺寸*/
  height: 0.5rem;
}
.nly-container-center::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #a1a1a1a6;
}

.nly-container-center::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ffffff;
}
.nly-container-center {
  // background-color: cornsilk;
  background-color: #fff;
  overflow: auto;
  height: 100%;
}

.nly-container-center-content {
  height: 100%;
  width: 100%;
  // background-color: wheat;
}

.nly-container-center-content-header {
  height: auto;
  background-color: #3190e8;
}

.nly-container-center-content-header-icon {
  background-color: transparent;
  color: #ffff;
  display: none;
}
.nly-container-center-content-header-brand {
  position: initial;
  display: none;
  .nly-container-center-content-header-brand-img {
    float: left;
    line-height: 0.8;
    margin-left: 0.8rem;
    margin-right: 0.5rem;
    margin-top: -3px;
    max-height: 33px;
    width: auto;
    border-radius: 50%;
    background-color: #ffffff00;

    .nly-container-center-content-header-brand-text {
      font-weight: 300;
      display: inline-block;
      margin-left: 0;
      opacity: 1;
      visibility: visible;
      transition: margin-left 0.3s linear, opacity 0.3s ease,
        visibility 0.3s ease;
    }
  }
}

.nly-container-center-content-main {
  background-color: #ffff;
  height: calc(~"100vh - 7.125rem");
  min-height: 380px;
}

.nly-container-center-content-main-breadcrumb-left {
  font-size: 1.3rem;
  color: rgb(105, 104, 104);
}

.nly-container-center-content-main-breadcrumb-right {
  display: flex;
}

.nly-container-center-content-main-card {
  margin: 0.5rem;
}

.nly-container-center-content-main-aside-toggle {
  display: block !important;
  border: 0;
  color: #fff !important;
}

.nly-container-center-content-main-aside-open-toggle {
  border: 0;
}

.nly-container-center-content-foot {
  height: 3.5625rem;
  background-color: #36d;
}

// .nly-container-aside-max-open-overlay {
//   background-color: rgba(0, 0, 0, 0.226);
//   bottom: 0;
//   display: none;
//   left: 0;
//   position: fixed;
//   right: 0;
//   top: 0;
//   z-index: 14;
// }

@media (max-width: 576px) {
  .nly-container-aside-max {
    height: 100%;
    width: 16rem;
    background-color: #343a40;
    left: -20rem;
    position: absolute;
    transition: 0.8s;
    z-index: @basezindex + 5;
  }

  .nly-container-aside-max
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-aside-max-open {
    height: 100%;
    width: 16rem;
    left: 0rem;
    background-color: #343a40;
    position: absolute;
    z-index: @basezindex + 10;
    transition: 0.8s;
  }

  .nly-container-aside-max-open
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max-open
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-center-content-main-aside-toggle {
    display: none !important;
  }
  .nly-container-aside-mini {
    height: 100%;
    width: 4.5rem;
    background-color: #343a40;
    transition: 0.5s;
    left: -10rem;
    position: absolute;
  }

  .nly-container-center-content-header-icon {
    background-color: transparent;
    display: block;
  }
  .nly-container-center-content-header-brand {
    position: initial;
    display: block;
    .nly-container-center-content-header-brand-img {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;

      .nly-container-center-content-header-brand-text {
        font-weight: 300;
        display: inline-block;
        margin-left: 0;
        opacity: 1;
        visibility: visible;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
      }
    }
  }

  .nly-container-aside-max-open-overlay {
    background-color: rgba(0, 0, 0, 0.226);
    bottom: 0;
    display: block;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 14;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .nly-container-aside-max {
    height: 100%;
    width: 16rem;
    background-color: #343a40;
    left: -20rem;
    position: absolute;
    transition: 0.8s;
    z-index: @basezindex + 5;
  }

  .nly-container-aside-max
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-aside-max-open {
    height: 100%;
    width: 16rem;
    left: 0rem;
    background-color: #343a40;
    position: absolute;
    z-index: @basezindex + 10;
    transition: 0.8s;
  }
  .nly-container-aside-max-open
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max-open
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-center-content-main-aside-toggle {
    display: none !important;
  }
  .nly-container-aside-mini {
    height: 100%;
    width: 4.5rem;
    background-color: #343a40;
    transition: 0.5s;
    left: -10rem;
    position: absolute;
  }

  .nly-container-center-content-header-icon {
    background-color: transparent;
    display: block;
  }

  .nly-container-center-content-header-brand {
    position: initial;
    display: block;
    .nly-container-center-content-header-brand-img {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;

      .nly-container-center-content-header-brand-text {
        font-weight: 300;
        display: inline-block;
        margin-left: 0;
        opacity: 1;
        visibility: visible;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
      }
    }
  }

  .nly-container-aside-max-open-overlay {
    background-color: rgba(0, 0, 0, 0.226);
    bottom: 0;
    display: block;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 14;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .nly-container-aside-max {
    height: 100%;
    width: 16rem;
    background-color: #343a40;
    left: -20rem;
    position: absolute;
    transition: 0.8s;
    z-index: @basezindex + 5;
  }
  .nly-container-aside-max
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-aside-max-open {
    height: 100%;
    width: 16rem;
    left: 0rem;
    background-color: #343a40;
    position: absolute;
    z-index: @basezindex + 10;
    transition: 0.8s;
  }

  .nly-container-aside-max-open
    > .nly-container-aside-brand
    > .nly-container-aside-brand-text {
    font-size: smaller;
    font-weight: 300;
    display: inline-block;
    margin-left: 0;
    opacity: 1;
    visibility: visible;
    transition: margin-left 0.3s linear, opacity 0.3s ease, visibility 0.3s ease;
  }

  .nly-container-aside-max-open
    > .nly-container-aside-sidebar
    > .nly-container-aside-sidebar-user-panel
    > .nly-container-aside-sidebar-user-panel-info
    > .nly-container-aside-sidebar-user-panel-info-block {
    font-size: smaller;
    display: block !important;
    color: rgba(255, 255, 255, 0.8);
  }

  .nly-container-center-content-main-aside-toggle {
    display: none !important;
  }
  .nly-container-aside-mini {
    height: 100%;
    width: 4.5rem;
    background-color: #343a40;
    transition: 0.5s;
    left: -10rem;
    position: absolute;
  }

  .nly-container-center-content-header-icon {
    background-color: transparent;
    display: block;
  }

  .nly-container-center-content-header-brand {
    position: initial;
    display: block;
    .nly-container-center-content-header-brand-img {
      float: left;
      line-height: 0.8;
      margin-left: 0.8rem;
      margin-right: 0.5rem;
      margin-top: -3px;
      max-height: 33px;
      width: auto;
      border-radius: 50%;
      background-color: #ffffff00;

      .nly-container-center-content-header-brand-text {
        font-weight: 300;
        display: inline-block;
        margin-left: 0;
        opacity: 1;
        visibility: visible;
        transition: margin-left 0.3s linear, opacity 0.3s ease,
          visibility 0.3s ease;
      }
    }
  }
  .nly-container-aside-max-open-overlay {
    background-color: rgba(0, 0, 0, 0.226);
    bottom: 0;
    display: block;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 14;
  }
}

@media (min-width: 993px) and (max-width: 1199px) {
}

@media (min-width: 1200px) {
}
.fade-enter,
.fade-leave-active {
  transform: translate3d(2rem, 1rem, 0);
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s;
}
.hover_p:hover {
  color: #36d;
}
.scrollContainer {
  // margin-top:30px;
  color: #ffffff;
  // display: flex;
  // align-items: center;
  font-size: 16px;
  // margin-left: 180px;
  width: 100%;
  line-height: 30px;
  overflow: hidden;
}
.scrollBox {
  margin-left: 100px;
  width: 30px;
  height: 30px;
}
.scroll_content {
  align-items: center;
}
.xia_zai {
  color: red;
}
.xia_zai:hover {
  color: #f4930a;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue